export const FETCH_PRODUCT = 'FETCH_PRODUCT'
export const FETCH_PROFILE = 'FETCH_PROFILE'
export const FETCH_CURRENT_USER = 'FETCH_CURRENT_USER'
export const SET_CARRINHO = 'SET_CARRINHO'

//PERFIL
export const FETCH_PERFIL = 'FETCH_PERFIL'
export const LOGOUT_PERFIL = 'LOGOUT_PERFIL'

//Lista de Produtos no Carrinho
export const ATUALIZAR_PRODUTOS = 'ATUALIZAR_PRODUTOS'
export const LIMPAR_PRODUTOS = 'LIMPAR_PRODUTOS'
export const REMOVER_PRODUTO = 'REMOVER_PRODUTO'
export const ADICIONAR_PRODUTO = 'ADICIONAR_PRODUTO'
export const EDITAR_PRODUTO = 'EDITAR_PRODUTO'
export const VALOR_ALEATORIO = 'VALOR_ALEATORIO'

//PRODUTO ATIVO
export const ATUALIZAR_PRODUTO_ATIVO = 'ATUALIZAR_PRODUTO_ATIVO'
export const REMOVER_PRODUTO_ATIVO = 'REMOVER_PRODUTO_ATIVO'
export const EDITAR_PRODUTO_CARRINHO = 'EDITAR_PRODUTO_CARRINHO'


//PIZZA ATIVA
export const ATUALIZAR_PIZZA_ATIVA = 'ATUALIZAR_PIZZA_ATIVA'
export const REMOVER_PIZZA_ATIVA = 'REMOVER_PIZZA_ATIVA'

//CLONE ATIVO
export const ATUALIZAR_CLONE_ATIVO = 'ATUALIZAR_CLONE_ATIVO'
export const REMOVER_CLONE_ATIVO = 'REMOVER_CLONE_ATIVO'

//ENDERECO ATIVO
export const ATUALIZAR_ENDERECO_ATIVO = 'ATUALIZAR_ENDERECO_ATIVO'
export const REMOVER_ENDERECO_ATIVO = 'REMOVER_ENDERECO_ATIVO'

//ABRIR/FECHAR MODAL
export const SHOW_MODAL = 'SHOW_MODAL'
export const HIDE_MODAL = 'HIDE_MODAL'

//ABRIR/FECHAR MODAL
export const SHOW_MODAL_ADDCARRINHO = 'SHOW_MODAL_ADDCARRINHO'
export const SHOW_MODAL_LOGIN = 'SHOW_MODAL_LOGIN'
export const SHOW_MODAL_ENDERECO = 'SHOW_MODAL_ENDERECO'
export const HIDE_MODAL_ENDERECO = 'HIDE_MODAL_ENDERECO'
export const SHOW_MODAL_FINALIZAR_COMPRA = 'SHOW_MODAL_FINALIZAR_COMPRA'
export const HIDE_MODAL_FINALIZAR_COMPRA = 'HIDE_MODAL_FINALIZAR_COMPRA'
export const HIDE_ALL_MODALS = 'HIDE_ALL_MODALS'





